export default __webpack_public_path__ + "static/image-21-4d56fa9e1e8f4577a11400891cc0e287.jpg";